import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { CacheService } from '@shared/services';

@Directive({
	selector: '[vQAccessControl]',
})
export class AccessControlDirective {
	@Input() set vQAccessControl(viewType: string) {
		this.cache.get('secure:loggedin').then(isLoggedin => {
			if (viewType === 'private' && isLoggedin) {
				this.viewContainer.createEmbeddedView(this.templateRef);
				return;
			}
			if (viewType === 'public' && !isLoggedin) {
				this.viewContainer.createEmbeddedView(this.templateRef);
				return;
			}
			this.viewContainer.clear();
			return;
		});
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - contructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(
		private readonly templateRef: TemplateRef<any>,
		private readonly viewContainer: ViewContainerRef,
		private readonly cache: CacheService
	) {}
}
